import { APP } from '@/src/features/app/app.constants';

export class IdentityNavigator {
  static buildLocationHref(path: string): string {
    return `${window.location.protocol}//${window.location.host}${path}`;
  }

  static buildLocationHrefWithRedirectPath(path: string): string {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('redirect');

    return redirect ? `${IdentityNavigator.buildLocationHref(path)}?redirect=${encodeURIComponent(redirect)}` : IdentityNavigator.buildLocationHref(path);
  }

  static goToForgetPasswordPage() {
    window.location.href = IdentityNavigator.buildLocationHrefWithRedirectPath(APP.ROUTES.FORGET_PASSWORD);
  };

  static goToRegisterPage() {
    window.location.href = IdentityNavigator.buildLocationHrefWithRedirectPath(APP.ROUTES.REGISTER);
  };

  static goToLoginPage() {
    window.location.href = IdentityNavigator.buildLocationHrefWithRedirectPath(APP.ROUTES.LOGIN);
  };

  static goToAuthenticatedPage() {
    const params = new URLSearchParams(window.location.search);

    window.location.href = params.get('redirect') || IdentityNavigator.buildLocationHref(APP.ROUTES.AUTHENTICATED);
  };
}